<template>
   <v-app>
      <div class="animated fadeIn">

         <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

         <v-switch
            dense
            v-model="listMode"
            @change="change_listMode"
            :label="$t('texts.list_mode')"
         >
         </v-switch>

         <ddoClientList key="StartingList1" v-if="!listMode" :loading="loading" :level="levels[0]" 
            :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
            :customSlotNames="levels[0].customSlotNames"
            @loading="refresh_loading"
            @childKey="refresh_childKey"
            @row="refresh_row"
            @errors="refresh_errors"
            >

            <template v-slot:superheader="{ errors }">
               <h1>{{ $t('titles.prc') }}</h1>
               <v-btn @click="sync_from_zoho(0)" class="error" rounded>{{ $t('buttons.sync_from_zoho') }}</v-btn>
               <br/><br/>
               <ddoAlert :errors="sync_errors"/>
               <br/>
            </template>

            <template v-slot:dialogform="{ row, level }">
               <CardUpdatableProductCategory ref="myCardProductCategory" :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
                  @errors="refresh_errors"
               />
            </template>

            <template slot="prc_level" slot-scope="props">
               <v-chip class="primary"><span>{{ props.row.prc_level }}</span></v-chip>
            </template>


            <template slot="_count" slot-scope="props">
               Produits : <v-chip class="primary"><span>{{ props.row.prc_pro_count }}</span></v-chip>
               Sous-catégories : <v-chip class="primary"><span>{{ props.row.prc_sub_count }}</span></v-chip>
            </template>

            <template v-slot:child_row="{ props }">
               <ddoClientList :loading="loading" :level="levels[1]" :childKey="levels[1].childKey"
                  :columns="levels[1].columns" :options="levels[1].options" :callbacks="levels[1].callbacks"
                  :customSlotNames="levels[1].customSlotNames"
                  @childKey="refresh_childKey"
                  @row="refresh_row"
                  >

                  <template v-slot:superheader="slotProps">
                     <h2>{{ $api._format($t('subtitles.pro'),slotProps.parentToggledRow['prc_code']) }}</h2>
                  </template>

                  <template v-slot:header="{ errors }">
                     <span></span>
                  </template>

                  <template v-slot:dialogform="{ row, level }">
                     <CardUpdatableProduct key="UpdateEQU1" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"/>
                  </template>

                  <template v-slot:child_row="{ props }">
                     <ddoClientList :loading="loading" :level="levels[2]" :childKey="levels[2].childKey"
                        :columns="levels[2].columns" :options="levels[2].options" :callbacks="levels[2].callbacks"
                        :customSlotNames="levels[2].customSlotNames"
                        @childKey="refresh_childKey"
                        @row="refresh_row"
                        >

                        <template v-slot:superheader="slotProps">
                           <h3>{{ $api._format($t('subtitles.pro_plans'),slotProps.parentToggledRow['pro_code']) }}</h3>
                        </template>

                        <template slot="pro_flags" slot-scope="props">
                           <b-checkbox disabled v-model="props.row.pro_visible_on_front">{{ $t('headers._visible') }}</b-checkbox>
                           <b-checkbox disabled v-model="props.row.pro_default_plan">{{ $t('headers._default') }}</b-checkbox>
                        </template>

                        <template slot="pro_image_link" slot-scope="props">
                           <div v-if="props.row.pro_image_link!=null">
                              <img v-bind:src="props.row.pro_image_link" width="50%" height="50%">
                           </div>
                        </template>

                        <template slot="pro_price" slot-scope="props">
                           <v-chip class="primary"><span>{{ $n(props.row.pro_price,'currency') }}</span></v-chip>
                        </template>

                        <template slot="pro_setup_price" slot-scope="props">
                           <v-chip class="primary"><span>{{ $n(props.row.pro_setup_price,'currency') }}</span></v-chip>
                        </template>

                        <template slot="pro_yearly_price" slot-scope="props">
                           <v-chip class="primary" v-if="props.row.pro_yearly_price!=null"><span>{{ $n(props.row.pro_yearly_price,'currency') }}</span></v-chip>
                        </template>

                        <template slot="pro_yearly_setup_price" slot-scope="props">
                           <v-chip class="primary" v-if="props.row.pro_yearly_setup_price!=null"><span>{{ $n(props.row.pro_yearly_setup_price,'currency') }}</span></v-chip>
                        </template>

                        <template v-slot:header="{ errors }">
                           <span></span>
                        </template>

                        <template v-slot:dialogform="{ row, level }">
                           <CardUpdatableProduct key="UpdateEQU2" :row="levels[2].row" :depth="levels[2].level" :level="levels[2]"/>
                           <!--<CardUpdatableProductplan :row="levels[2].row" :depth="levels[2].level" :level="levels[2]"/>-->
                        </template>

                     </ddoClientList>
                  </template>
               </ddoClientList>
            </template>

         </ddoClientList>

         <ddoClientList name="StartingList2" key="StartingList2" v-if="listMode" :loading="loading" :level="levels[4]"
            :columns="levels[4].columns" :options="levels[4].options" :callbacks="levels[4].callbacks"
            :customSlotNames="levels[4].customSlotNames"
            @childKey="refresh_childKey"
            @row="refresh_row"
            ref="myPRODUCTList2"
            >

            <template v-slot:superheader="slotProps">
               <h1>{{ $t('titles.pro') }}</h1>
               <v-btn @click="sync_from_zoho(4)" class="error" rounded>{{ $t('buttons.sync_from_zoho') }}</v-btn>
               <br/><br/>
            </template>

            <template v-slot:header="{ errors }">
               <span></span>
            </template>

            <template slot="searchengine" slot-scope="props">
            </template>

            <template v-slot:dialogform="{ row, level }">
               <CardUpdatableProduct key="UpdateEQU4" :row="levels[4].row" :depth="levels[4].level" :level="levels[4]"/>
               <!--<CardUpdatableProduct key="UpdateEQU2" :row="levels[4].row" ref="myCardEquipment" :depth="levels[4].level" :level="levels[4]"/>-->
            </template>

         </ddoClientList>

      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import ddoClientList from '@/components/ddoClientList.vue';
import { Event } from '@/components/ddoClientList.vue';

import CardUpdatableProductCategory from '@/components/partials/CardUpdatableProductCategory.vue';
import CardUpdatableProduct from '@/components/partials/CardUpdatableProduct.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';

let initial_row = {}

Vue.use(Event);

export default {
   name: 'product',
   components: {
      ddoAlert,
      ddoWaiting,
      ddoClientList,
      CardUpdatableProductCategory,
      CardUpdatableProduct,
      ddoSelect2,
   },
   data: () => {
      return {
         _this: null,
         loading: false,
         listMode: false,

         sync_errors: [],

         levels: [

         /* 
          * LEVEL 1 : all for ddoClientList : columns, options, callbacks
          */
         {
            api_code: 'productcategory',
            api_prefix: 'prc',
            row: {},
            level: 0,
            errors: [],
            columns: [ '_actions', 'prc_level', 'prc_code', 'prc_name', '_count', '_update'],
            customSlotNames: ['prc_level', '_count'],
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: true,
               hiddenColumns: [],
               headings: {
                  _pk: i18n.t('headers.actions'),
                  _child: i18n.t('headers.actions'),
                  _count: i18n.t('headers._counters'),
                  prc_level: i18n.t('headers.prc_level'),
                  prc_code: i18n.t('headers.code'),
                  prc_name: i18n.t('headers.prc_name'),
                  prc_desc: i18n.t('headers.description'),
                  _update: i18n.t('headers.updated_on')
               },
               texts: {
               },
               uniqueKey: 'prc_pk',
               sortable: ['prc_code','prc_update'],
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               columnsDropdown: false,
               pagination: {
                  chunk: 5,
                  edge: false,
                  nav: 'scroll'
               },
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.prc_create_title'),
                  update: i18n.t('texts.prc_update_title'),
                  delete: i18n.t('texts.prc_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               header_value_function: function(row) { return row['dtc_code']; }
            },
         },

         {
            /* 
            * LEVEL 2 : all for ddoClientList : columns_l2, options_l2, callbacks_l2
            */
            api_code: 'product',
            api_prefix: 'pro',
            row: {},
            level: 1,
            errors: [],
            columns: [ '_actions', 'prt_bm_entity_name', 'pro_code', 'pro_name', '_update' ],
            nestedSlots: [],
            options: {
               showChildRowToggler: false,
               withChild: true,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  _child: i18n.t('headers.actions'),
                  pro_code: 'Code',
                  prt_bm_entity_name: i18n.t('headers.prt_bm_entity_name'),
                  pro_name: i18n.t('headers.pro_name'),
                  _update: i18n.t('headers.updated_on')
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'pro_pk',
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.pro_create_title'),
                  update: i18n.t('texts.pro_update_title'),
                  delete: i18n.t('texts.pro_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               parentKeyName: 'prc_pk',
               header_value_function: function(row) { return row['pro_code']; }
            },
         },

         {
            /* 
               * LEVEL 3 : all for ddoClientList : columns_l3, options_l3, callbacks_l3
               */
            api_code: 'product',
            api_prefix: 'pro',
            row: {},
            level: 2,
            errors: [],
            columns: [ '_actions', 'pro_image_link', 'pro_code', 'pro_name', 'pro_flags', 'pro_price', 'pro_setup_price', 'pro_yearly_price', 'pro_yearly_setup_price', '_update' ],
            customSlotNames: ['pro_image_link','pro_flags','pro_price','pro_setup_price','pro_yearly_price','pro_yearly_setup_price'],
            nestedSlots: [],
            options: {
               showChildRowToggler: false,
               withChild: false,
               headings: {
                  _child: i18n.t('headers.actions'),
                  _pk: i18n.t('headers.actions'),
                  pro_name: i18n.t('texts.pro_name'),
                  pro_code: i18n.t('headers.code'),
                  pro_image_link: i18n.t('texts.pro_image_link'),
                  pro_price: i18n.t('texts.pro_price'),
                  pro_setup_price: i18n.t('texts.pro_setup_price'),
                  pro_yearly_price: i18n.t('texts.pro_yearly_price'),
                  pro_yearly_setup_price: i18n.t('texts.pro_yearly_setup_price'),
                  _update: i18n.t('headers.updated_on'),
               },
               perPage: 100,
               perPageValues: [100,200,400],
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'pro_pk',
               columnsClasses: {
                  pro_image_link: 'image_logo_120',
                  pro_price: 'text-right',
                  pro_setup_price: 'text-right',
                  pro_yearly_price: 'text-right',
                  pro_yearly_setup_price: 'text-right',
               }
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.pro_create_title'),
                  update: i18n.t('texts.pro_update_title'),
                  delete: i18n.t('texts.pro_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               parentKeyName: 'pro_pk',
               header_value_function: function(row) { return row['pro_code']; }
            },
         },

         {
            /* 
            * LEVEL 4 : all for ddoClientList : columns_l4, options_l4, callbacks_l4
            */
            api_code: 'product',
            api_prefix: 'pro',
            row: {},
            level: 3,
            errors: [],
            columns: [ '_actions', 'pro_code', 'pro_name', 'pro_price', 'prt_name', '_update' ],
            customSlotNames: ['equ_position_from'],
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: false,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  pro_code: i18n.t('texts.pro_code'),
                  pro_name: i18n.t('texts.pro_name'),
                  pro_price: i18n.t('texts.pro_price'),
                  prt_name: i18n.t('texts.prt_name'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'equ_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.pro_create_title'),
                  update: i18n.t('texts.pro_update_title'),
                  delete: i18n.t('texts.pro_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               parentKeyName: 'pro_pk',
               header_value_function: function(row) { return row['pro_name']; }
            },
         },

         {
            /* 
             * LEVEL 5 : all for ddoClientList : columns_l5, options_l5, callbacks_l5
             */
            api_code: 'product',
            api_prefix: 'pro',
            row: {},
            level: 4,
            errors: [],
            columns: [ '_actions', 'prt_bm_entity_name', 'pro_code', 'pro_name', 'prt_name', '_update' ],
            searchValues: {
               eqt_is_virtual: null,
               equ_name: null,
            },
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: false,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  pro_code: i18n.t('texts.pro_code'),
                  pro_name: i18n.t('texts.pro_name'),
                  prt_name: i18n.t('texts.eqt_name'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               perPage: 100,
               perPageValues: [100,200,400],
               customFilters: [{
                  name: 'search',
                  callback: function (row, query) {
                     let $ret = true;
                     //console.log('callback, name='+row.pro_name+', ret='+$ret)
                     return $ret;
                  }
               }],
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'equ_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.pro_create_title'),
                  update: i18n.t('texts.pro_update_title'),
                  delete: i18n.t('texts.pro_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               header_value_function: function(row) { return row['pro_name']; },
               parentKeyName: null,
           },
         },

         ],

         model: {},
         dialogShow: false,
         dialogId: null,
         dialogcode: null,

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
      this._this = this;
      
      this.levels[0].callbacks.configure_form = this.configure_form;
      this.levels[0].callbacks.show_dialog    = this.show_dialog;
      this.levels[0].callbacks.refresh_rows   = this.refresh_rows_l1;
      this.levels[0].callbacks.prepare_create = this.prepare_create;
      this.levels[0].callbacks.prepare_update = this.prepare_update;
      this.levels[0].callbacks.prepare_delete = this.prepare_delete;
      this.levels[0].callbacks.refresh_errors = this.refresh_errors;

      this.levels[1].callbacks.refresh_rows   = this.refresh_rows_l2;
      this.levels[1].callbacks.prepare_create = this.prepare_create_l2;    
      this.levels[1].callbacks.prepare_update = this.prepare_update_l2;
      this.levels[1].callbacks.configure_form = this.configure_form;
      this.levels[1].callbacks.show_dialog    = this.show_dialog;
      this.levels[1].callbacks.refresh_errors = this.refresh_errors;

      this.levels[2].callbacks.refresh_rows   = this.refresh_rows_l3;
      this.levels[2].callbacks.prepare_create = this.prepare_create_l3;
      this.levels[2].callbacks.configure_form = this.configure_form;
      this.levels[2].callbacks.show_dialog    = this.show_dialog;
      this.levels[2].callbacks.refresh_errors = this.refresh_errors;

      this.levels[3].callbacks.refresh_rows   = this.refresh_rows_l4;
      this.levels[3].callbacks.prepare_create = this.prepare_create_l4;
      this.levels[3].callbacks.prepare_update = this.prepare_update_l4;
      this.levels[3].callbacks.create_row     = this.create_row_l4;
      this.levels[3].callbacks.update_row     = this.update_row_l4;
      this.levels[3].callbacks.configure_form = this.configure_form;
      this.levels[3].callbacks.show_dialog    = this.show_dialog;
      this.levels[3].callbacks.refresh_errors = this.refresh_errors;

      this.levels[4].callbacks.refresh_rows   = this.refresh_rows_l5;
      this.levels[4].callbacks.prepare_create = this.prepare_create_l4;
      this.levels[4].callbacks.prepare_update = this.prepare_update_l5;
      this.levels[4].callbacks.create_row     = this.create_row_l4;
      this.levels[4].callbacks.update_row     = this.update_row_l4;
      this.levels[4].callbacks.configure_form = this.configure_form;
      this.levels[4].callbacks.show_dialog    = this.show_dialog;
      this.levels[4].callbacks.refresh_errors = this.refresh_errors;
   },

   mounted() {
   },

   methods: {

      async change_listMode(value) {
         if ( value===true ) {
            this.levels[4].errors = [];
            this.levels[4].rows = [];
         } else {
            this.levels[0].errors = [];
            this.levels[0].rows = [];
         }
         this.sync_errors = [];
      },

      build_positions(row) {
         console.log('build_positions')
      },

      refresh_loading(value) {
         this.loading = value;
      },
      refresh_errors(level,errors) {
         this.levels[level].errors = errors;
      },
      refresh_row(level,row) {
         this.levels[level].row = row;
      },

      async refresh_rows_l1(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code);
         this.loading = false;
         /*
          * We restructure the counters :
          * - we create prc_pro_count (count of Products) by copying from _count
          * - we replace _count by the sum of prc_pro_count and prc_sub_count. Which is required by ddoClientList,
          *   for validating/invalidating the "Delete" button.
          */
         if ( api_response.error==0 && api_response.rows ) {
            for( var i=0;i<api_response.rows.length;i++ ) {
               api_response.rows[i].prc_pro_count = api_response.rows[i]._count;
               api_response.rows[i]._count = parseInt(api_response.rows[i]._count)+parseInt(api_response.rows[i].prc_sub_count);
            }
         }
         return { errorinfos, api_response }
      },

      async refresh_rows_l2(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+key+'/products');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async refresh_rows_l3(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[1].api_code+'/'+key+'/plans');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async refresh_rows_l4(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[2].api_code+'/'+key+'/equipments');
         this.loading = false;
         if ( api_response.error==0 && api_response.rows ) {
            for( var i=0;i<api_response.rows.length;i++ ) {
               let min = api_response.rows[i].pro_position_from;
               let max = api_response.rows[i].pro_position_to;
               min = ( min!=null ? min : 0 );
               max = ( max!=null ? max : min);
               api_response.rows[i].pro_position_to = max;
               api_response.rows[i].pro_positions = [ min, max ];
            }
         }
         return { errorinfos, api_response }
      },

      async refresh_rows_l5(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[4].api_code);
         this.loading = false;
         if ( api_response.error==0 && api_response.rows ) {
            for( var i=0;i<api_response.rows.length;i++ ) {
               api_response.rows[i]._count = 1;
            }
         }
         return { errorinfos, api_response }
      },

      refresh_childKey(level,key,toggledRow=null) {
         this.levels[level].childKey = key;
         this.levels[level].toggledRow = toggledRow;
      },

      configure_form(level,f_disabled,f_create,f_update,f_delete) {
         let _dV = this.levels[level].dialogValues;
         _dV.form_disabled = f_disabled;
         _dV.form_create   = f_create;
         _dV.form_update   = f_update;
         _dV.form_delete   = f_delete;
         this.levels[level].dialogValues = _dV;
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         _dV.dialogShow   = show;
         this.levels[level].dialogValues = _dV;
      },

      async prepare_create(parentKey=null) {
         this.levels[0].errors = [];
         this.levels[0].row.array_patterns = [];
         this.$refs.myCardProductCategory.PRCoptions.selected  = null;
      },

      async prepare_update(parentKey=null) {
         this.levels[0].errors = [];
         this.$refs.myCardProductCategory.PRCoptions.selected  = this.levels[0].row.prc_pk_parent;
      },

      async prepare_delete(parentKey=null) {
         this.levels[0].errors = [];
         this.$refs.myCardProductCategory.PRCoptions.selected  = this.levels[0].row.prc_pk_parent;
      },

      prepare_create_l2(parentKey=null,origin=null) {
         this.levels[1].errors = [];
         if ( this.levels[1].dialogValues.parentKeyName ) {
            this.levels[1].row[this.levels[1].dialogValues.parentKeyName] = parentKey;
         } 
      },

      async prepare_update_l2(parentKey=null) {
         this.levels[1].errors = [];
      },

      prepare_create_l3(parentKey=null,origin=null) {
         this.levels[2].errors = [];
         if ( this.levels[2].dialogValues.parentKeyName ) {
            this.levels[2].row[this.levels[2].dialogValues.parentKeyName] = parentKey;
         } 
      },

      prepare_create_l4(parentKey=null,origin=null) {
         this.levels[3].errors = [];
         this.levels[3].row = {};
         if ( this.levels[3].toggledRow ) {
         }
      },

      prepare_update_l4(parentKey=null,_pk,row=null,origin=null) {
         this.levels[3].errors = [];
      },

      prepare_update_l5(parentKey=null,_pk,row=null,origin=null) {
         this.levels[4].errors = [];
      },

      async create_row_l4(router,api_code,row) {
         if ( row.pro_positions && row.pro_positions.length==2 ) {
            row.pro_position_from = row.pro_positions[0];
            row.pro_position_to   = row.pro_positions[1];
         }
         var { errorinfos, api_response } = await this.$api.createRow(router,api_code,row);
         return { errorinfos, api_response }
       },

      async update_row_l4(router,api_code,_pk,row) {
         if ( row.pro_positions && row.pro_positions.length==2 ) {
            row.pro_position_from = row.pro_positions[0];
            row.pro_position_to   = row.pro_positions[1];
         }
         var { errorinfos, api_response } = await this.$api.updateRow(router,api_code,_pk,row);
         return { errorinfos, api_response }
       },

      async sync_from_zoho(level) {
         this.sync_errors = [];
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'probe/SYNC_BM_ZOHO_PRODUCTS/sync');
         this.loading = false;
         if ( api_response.error==0 ) {
            if ( api_response.rows ) {
               if ( api_response.rows==null || api_response.rows.length==0 ) {
                  this.sync_errors = [ errorinfos ];
               }
               for ( var i=0;i<api_response.rows.length;i++ ) {
                  if ( i==0 ) {
                     this.sync_errors = [ api_response.rows[0] ];
                  } else {
                     this.sync_errors[0].err_value_text += '\n' + api_response.rows[i].err_value_text;
                  }
               }
            }
         } else {
            this.levels[level].errors = [ errorinfos ];
         }
      },

      filter_rows(level) {
         Event.$emit('vue-tables.filter::search', this.levels[level].searchValues);
      },
   }
}
</script>

<style>
   image_logo_120 {
      width: 120px !important;
   }
</style>